<footer class="container-fluid text-secondary text-start border-top small-border small border-white shadow px-0">
    <div class="row bg-white cursor-pointer d-flex align-items-center" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
        <div class="col-3 d-flex justify-content-start">
            <p class="py-3 my-0 ms-4">
                {{currentDate|date: 'yyyy'}} © ALDDA Virtual, S.A. de C.V. <small class="ms-3">v 1.0.52</small>
            </p>

        </div>
        <div class="col-6 d-flex justify-content-center">
            <h4 for="" class="text-primary fw-bold text-center">Totales <i class="fas fa-certificate text-warning" style="font-size: .8rem;"></i></h4>
        </div>
        <div class="col-3 d-flex justify-content-end">
            <i class="fas fas-3x text-warning fw-bold me-4" [ngClass]="{'fa-chevron-down': !isCollapsed , 'fa-chevron-up' : isCollapsed}" style="font-size: 1.5rem;"></i>
        </div>
    </div>
    <div id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true" class="px-0">
        <div class="row bg-success d-flex justify-content-center py-3">
            <div class="col-2 text-center text-primary h5 ">
                <div class="position-relative">
                    <div class="bg-white rounded-circle position-absolute top-50 start-50 translate-middle bg-gauge"></div>
                    <ngx-gauge *ngIf="isBrowser" class="position-relative" [type]="'full'" [cap]="'butt'" [value]="3" [max]="info.totalDays" [size]="130" [thick]="8" [foregroundColor]="'#ffc107'" [backgroundColor]="'#00A88F'">
                    </ngx-gauge>
                </div>
                <label class="text-white mb-0">Cierre del mes</label>
            </div>
            <div class="col-2 text-center text-primary h5 ">
                <div class="position-relative">
                    <div class="bg-white rounded-circle position-absolute top-50 start-50 translate-middle bg-gauge"></div>
                    <ngx-gauge *ngIf="isBrowser" class="position-relative" [type]="'full'" [cap]="'butt'" [value]="info.contractCount - info.completedContractCount" [max]="info.contractCount" [size]="130" [thick]="8" [foregroundColor]="'#122048'" [backgroundColor]="'#00A88F'">
                    </ngx-gauge>
                </div>
                <label class="text-white mb-0">Expedientes incompletos</label>
            </div>
            <div class="col-2 text-center text-primary h5 ">
                <div class="position-relative">
                    <div class="bg-white rounded-circle position-absolute top-50 start-50 translate-middle bg-gauge"></div>
                    <ngx-gauge *ngIf="isBrowser" class="position-relative" [type]="'full'" [cap]="'butt'" [max]="6" [value]="info.completedContractCount" [max]="info.contractCount" [size]="130" [thick]="8" [foregroundColor]="'#122048'" [backgroundColor]="'#00A88F'">
                    </ngx-gauge>
                </div>
                <label class="text-white mb-0">Expedientes completos</label>
            </div>
        </div>
    </div>
</footer>
